<template>
  <v-layout
    :style="heightOverflow"
    row
    wrap>
    <v-flex xs12>
      <Titulo/>
    </v-flex>
    <v-flex xs12>
      <Menu/>
    </v-flex>
    <v-container
      grid-list-md>
      <v-layout
        row
        wrap>
        <v-layout
          wrap
          flex
          row>
          <v-flex
            xs12
            md12>
            <material-card
              id="alimentos_custo_medio"
              :text="strings[idioma].custo_medio"
              :color="colorCard"
              text-xs-center>
              <v-text-field
                :label="strings[idioma].pesquisar"
                v-model="search"
                flat

                hide-details
                clearable
                append-icon="mdi-magnify"
                clear-icon="mdi-close"/>
              <v-divider/>

              <v-treeview
                ref="dTreeAlimentos"
                :style="heightTree"
                :items="categorias_alimentos.filter(c => c.id < 900)"
                :search="search"
                :filter="filter"
                :item-text="!idioma ? 'name' : 'name_en'"
                :open.sync="open"
                :open-all="expandeArvore"
                item-children="derivados"

                active-class = ""
                selected-color="primary"
                activatable
                transition
                expand-icon="mdi-chevron-down"
                indeterminate-icon="mdi-minus-box"
                return-object
              >
                <template
                  slot="label"
                  slot-scope= "{ item }">
                  <span
                    v-if="item.derivados"
                    style="cursor: pointer; font-weight: 400; text-decoration-color: grey;"
                    @click="open = (open[0] !== item) ? [item] : []"> {{ idioma === 0 ? item.name : idioma === 1 ? item.name_en: item.name_es }} </span>
                  <span
                    v-else
                    style="cursor: pointer; font-weight: 200; text-decoration-color: grey; text-size: 10px!important;"> {{ idioma === 0 ? item.name : idioma === 1 ? item.name_en: item.name_es }} ---> <span style="color: red"> {{ strings[idioma].moeda + ' ' + getCustoMedioPessoal(item) + '' }} </span>  | <span style="color: blue">{{ strings[idioma].moeda + ' ' + getCustoMedio(item) + '' }}</span> </span>
                </template>
              </v-treeview>
              <span>{{ strings[idioma].legenda }}: </span>
              <span style="color: red">{{ strings[idioma].na_sua_conta }}</span> | <span style="color: blue">{{ strings[idioma].em_todo_brcorte }}</span>
            </material-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-layout>
</template>
<script>
import Titulo from './components/Titulo'
import Menu from './components/Menu'
import { mapState } from 'vuex'
export default {
  components: {
    Titulo,
    Menu
  },
  data () {
    return {
      search: null,
      expandeArvore: false,
      open: [],
      alimentos_custo_usr: [],
      clientes: []
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas']),
    filter () {
      return (item, search, textKey) => item[textKey].toLowerCase().search(search.toLowerCase()) > -1
    },
    colorCard () {
      return 'indigo lighten-5'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 200) + 'px; overflow: auto; min-height: 200px;'
    }

  },
  created () {
    this.loadAlimentosDieta()
    this.getClientes()
  },
  methods: {
    getClientes () {
      if (!this.user.consultoria || !this.user.consultoria.id || this.user.consultoria.EXCLUIDO) return null
      return this.axios.post('consultoria/clientes', { id: this.user.consultoria.id }).then(r => {
        this.clientes = r.data.data
        return this.clientes
      })
    },
    getCustoMedioPessoal (al, prefix = '') {
      if (!this.alimentos_custo_usr[prefix + al.id] || this.alimentos_custo_usr[prefix + al.id] === null || this.alimentos_custo_usr[prefix + al.id].length === 0) return '(-)'
      let alCustos = this.alimentos_custo_usr[prefix + al.id].filter(a => a !== null && a > 0)
      if (!alCustos || alCustos === null || alCustos.length <= 0) return '(-)'
      return (this.stats.median(alCustos)).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    getCustoMedio (al, prefix = '') {
      if (!this.alimentos_custo[prefix + al.id] || this.alimentos_custo[prefix + al.id] === null || this.alimentos_custo[prefix + al.id].length === 0) return '(-)'
      let alCustos = this.alimentos_custo[prefix + al.id].filter(a => a !== null && a > 0)
      if (!alCustos || alCustos === null || alCustos.length <= 3) return '(-)'
      return (this.stats.median(alCustos)).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    getCustoEmpresaMedio (al, prefix = '') {
      if (!this.alimentos_custo_empresa[prefix + al.id] || this.alimentos_custo_empresa[prefix + al.id] === null || this.alimentos_custo_empresa[prefix + al.id].length === 0) return '(-)'
      let alCustos = this.alimentos_custo_empresa[prefix + al.id].filter(a => a !== null && a > 0)
      if (!alCustos || alCustos === null || alCustos.length === 0) return '(-)'
      return (this.stats.median(alCustos)).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    getCustos (al) {
      this.axios.post('users/getCustos', {}).then((res) => {
        this.alimentos_custo = res.data.data
        this.alimentos_custo_usr = {}
        try {
          this.alimentos_custo_usr = JSON.parse(this.user.custos)
        } catch (e) {}
      })
    },
    loadAlimentosDieta () {
      this.loadingAlimentos = true
      this.loadingStep1 = true

      this.axios.post('alimentos/lastUpdateAt', {}).then(response => {
        let lastUpdate = parseInt(response.data.data[1])

        if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
          if (this.categorias_alimentos) {
            this.loadingStep1 = this.loadingAlimentos = false
            return
          }
          let tipos = JSON.parse(localStorage.getItem('tipos'))
          let alimentos = JSON.parse(localStorage.getItem('alimentos'))
          this.$store.commit('setAlimentos', {
            tipos: tipos,
            alimentos: alimentos
          })
          this.loadingAlimentos = false
          this.loadingStep1 = false
        } else {
          this.axios.post('tipos', {}).then(response => {
            let tipos = response.data.data
            localStorage.setItem('tipos', JSON.stringify(tipos))
            this.axios.post('relatorio/alimentosBrCorte', {}).then(response => {
              localStorage.setItem('alimentos', JSON.stringify(response.data.data))
              this.$store.commit('setAlimentos', {
                tipos: tipos,
                alimentos: response.data.data
              })
              this.loadingAlimentos = false
              this.loadingStep1 = false
              localStorage.setItem('lastUpdate', lastUpdate)
            }).catch(error => {
              console.log(error)
            })
          })
        }
      }).catch(reason => {
        console.log(reason)
      }).then(() => {
        this.getCustos()
      })
    }
  }

}
</script>
